import { toast } from "react-toastify";

export const checkIfAuthError = (onSignOut: () => void): boolean => {
  const params = new URLSearchParams(window.location.search);

  const errorDescription = params.get("error_description");

  if (errorDescription) {
    onSignOut();

    toast.error(errorDescription);
  }

  return !!errorDescription;
};
